<template>
  <b-modal ref="invateNewUserModal" hide-footer centered title="Invite User" :busy="inProcess">
    <b-form @submit.prevent="save">
      <b-form-group label="Role:">
        <b-form-select
          :options="availableRoles"
          v-model="$v.selectedRoles.$model"
          :class="{ 'is-invalid': $v.selectedRoles.$error }"
          :disabled="inProcess"
          multiple
        ></b-form-select>
        <b-form-invalid-feedback
          v-if="!$v.selectedRoles.isSelected"
        >At least one role must be specified</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="E-mail:">
        <b-form-input
          v-model="$v.email.$model"
          :class="{ 'is-invalid': $v.email.$error }"
          placeholder="example@domain.com"
          :disabled="inProcess"
        />
        <b-form-invalid-feedback v-if="!$v.email.required">E-mail is required</b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="!$v.email.email"
        >This field should contain a valid E-mail address</b-form-invalid-feedback>
      </b-form-group>
      <div v-if="!isSignedUp">
        <b-form-group label="Password:" v-if="!autoPass">
          <b-form-input
            v-model="$v.pass.$model"
            :class="{ 'is-invalid': $v.pass.$error }"
            :disabled="inProcess"
          />
          <b-form-invalid-feedback v-if="!$v.pass.required">Password is required</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="autoPass" :disabled="inProcess">Generate password</b-form-checkbox>
        </b-form-group>
      </div>
      <b-form-group>
        <b-form-checkbox v-model="invite" :disabled="inProcess">Send invitation</b-form-checkbox>
      </b-form-group>
      <div>
        <b-button variant="primary" type="submit" :disabled="inProcess">Save</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import { find } from 'lodash'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
import auth from '@/services/auth'
import user from '@/services/user'

export default {
  data() {
    return {
      email: null,
      autoPass: true,
      pass: null,
      invite: true,
      availableRoles: [
        { value: 'read', text: 'Regular' },
        { value: 'update', text: 'Dashboard editor' },
        { value: 'manageUsers', text: 'User manager' },
      ],
      selectedRoles: ['read'],
      inProcess: false,
    }
  },
  computed: {
    ...mapState(['currentDash', 'userListAll']),
    availableDashboards() {
      const items = []

      for (let dId in this.dashboards) {
        const dashboard = this.dashboards[dId]

        items.push({
          value: dId,
          text: dashboard.name,
        })
      }

      return items
    },
    isSignedUp() {
      if (!this.userListAll) return false

      for (let user of this.userListAll) {
        if (user.email === this.email) return true
      }

      return false
    },
  },
  methods: {
    closeModal() {
      if (this.$refs['invateNewUserModal']) {
        this.$refs['invateNewUserModal'].hide()
      }
    },
    async save() {
      if (this.inProcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProcess = true

      const rules = {}

      for (let rule of this.selectedRoles) {
        rules[rule] = true
      }

      const data = {
        email: this.email,
        invite: this.invite,
        dashboard: this.currentDash,
        rules,
        idToken: await auth.getIdToken()
      }

      if (!this.isSignedUp) {
        if (this.autoPass) data.pass = this.genPass(6)
        else data.pass = this.pass

        user
          .create(data)
          .then(res => {
            if (res.data.status === 'OK') {
              this.resetData()
            } else {
              this.$store.commit('addError', res.data.err)
              this.inProcess = false
            }
          })
          .catch(err => {
            this.inProcess = false
            console.error(err)
          })
      } else {
        data.uid = find(this.userListAll, { email: this.email }).uid

        user
          .addToDashboard(data)
          .then(res => {
            if (res.data.status === 'OK') {
              this.resetData()
            } else {
              this.$store.commit('addError', res.data.err)
              this.inProcess = false
            }
          })
          .catch(err => {
            this.inProcess = false
            console.error(err)
          })
      }
    },
    genPass(length) {
      var text = ''
      var possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }

      return text
    },
    resetData() {
      this.inProcess = false
      this.email = null
      this.selectedRoles = ['read']
      this.pass = null
      this.autoPass = true
      this.invite = true
      this.$nextTick(() => {
        this.$v.$reset()
      })
      this.closeModal()
    }
  },
  async created() {
    eventBus.$on('showInvateNewUserModal', () => {
      if (this.$refs['invateNewUserModal']) {
        this.$refs['invateNewUserModal'].show()
      }
    })
  },
  mounted() {
    if (this.$refs['invateNewUserModal']) {
      $(this.$refs['invateNewUserModal']['$el']).appendTo('body')
    }
  },
  beforeDestroy() {
    if (this.$refs['invateNewUserModal']) {
      $(this.$refs['invateNewUserModal']['$el']).remove()
    }
  },
  validations: {
    selectedRoles: {
      isSelected(val) {
        if (!val.length) return false
        return true
      },
    },
    email: {
      required,
      email,
    },
    pass: {
      required(val) {
        if (this.autoPass) return true
        if (val && val.length) return true
        return false
      },
    },
  },
}
</script>
